export enum ESortDirection {
    DESC,
    ASC
}
